module.exports = "/_next/static/images/contact-graphic-e4aa62827a03d371703d34de70914b81.png";